<template>
  <el-scrollbar>
    <div class="form">
      <!-- <h3>注册协议和隐私条款</h3>
            <div class="border"></div> -->
      <p>
        欢迎您在国家文物局综合行政管理平台注册，在您注册成为用户以及接受系统服务之前，请确认您已充分阅读、理解并接受本协议的全部内容，一旦您使用系统服务，即表示您同意遵循本协议之所有约定。
      </p>
      <ul>
        <li>
          一、协议适用主体范围
          <p>
            国家文物局综合行政管理平台的运营管理权归国家文物局所有。本协议是您和国家文物局，明确双方通过国家文物局综合行政管理平台查询、办理网上政务服务事项、网上留言等过程中的权利义务所订立的协议。订立本协议的用户，应当是具备完全民事权利能力和完全民事行为能力的法人。
          </p>
        </li>
        <li>
          二、服务内容
          <p>
            国家文物局综合行政管理平台为用户提供网上政务服务，服务的具体内容由国家文物局综合行政管理平台根据实际情况提供。国家文物局综合行政管理平台保留随时变更、中断或终止部分或全部网络服务的权利。
            注册用户在国家文物局综合行政管理平台能够进行政务服务信息查询、政务服务事项办理等，可在专属用户空间使用实名验证、个人信息维护、我的办件、我的咨询、我的投诉、我的收藏、我的足迹等个性化服务。
          </p>
        </li>
        <li>
          三、注册信息提供及账号管理
          <p>
            注册用户的账号所有权归属国家文物局综合行政管理平台，用户在注册账号时，应当按注册页面引导提供真实、准确、最新和完整的法人资料，使用统一社会信用代码/电子营业执照/数字证书等有效信息进行实名验证。用户阅读并同意本协议且完成全部注册程序后，即可获得国家文物局综合行政管理平台账号并成为国家文物局综合行政管理平台用户，请按以下规则管理账号：
          </p>
          <ol>
            <li>不得以虚假信息或其他违法和不良信息进行注册。</li>
            <li>不得将账号、密码转让或出借予他人使用。</li>
            <li>
              若违反相关法律法规和本协议各项规定，国家文物局综合行政管理平台有权对该用户账号单方采取暂停使用、注销登记等措施。
            </li>
            <li>
              若服务被终止或取消，国家文物局综合行政管理平台可以从服务器上永久地删除该用户的数据；服务终止或取消后，国家文物局综合行政管理平台没有义务向用户返还或恢复任何数据。
            </li>
          </ol>
        </li>
        <li>
          四、用户承诺和授权
          <p>注册用户在使用国家文物局综合行政管理平台账号时承诺并确认：</p>
          <ol>
            <li>
              遵守中国法律和法规，遵守所有与网络服务有关的网络协议、规定和程序。
            </li>
            <li>
              不得利用国家文物局综合行政管理平台进行任何可能对互联网的正常运转造成不利影响的行为。
            </li>
            <li>
              不得利用国家文物局综合行政管理平台进行任何不利于国家文物局综合行政管理平台的行为。
            </li>
            <li>
              用户应当对其所提供内容的真实性、合法性负责，不得出现违法和不良信息。
            </li>
            <li>用户同意接收国家文物局综合行政管理平台推送的信息。</li>
            <li>
              用户上传到国家文物局综合行政管理平台的除个人信息以外的文字、图片和音视频等内容，国家文物局综合行政管理平台具有免费使用权。
            </li>
            <li>
              国家文物局综合行政管理平台提供的网络服务内容可能包括：文字、软件、声音、图片、视频、图表等。所有这些内容受版权、商标和其他财产所有权法律的保护，用户只有在获得国家文物局综合行政管理平台或其他相关权利人的授权之后才能使用这些内容。
            </li>
          </ol>
        </li>
        <li>
          五、隐私保护
          <p>
            国家文物局综合行政管理平台尊重并保护用户的个人隐私权，您的用户账号、办件信息、证照等用户资料，非经您亲自许可或根据相关法律、法规的强制性规定，不会主动地泄露或以任何形式向任何第三方提供。但下列情况除外：
          </p>
          <ol>
            <li>事先获得用户的明确授权；</li>
            <li>根据有关的法律法规要求；</li>
            <li>按照相关政府主管部门的要求；</li>
            <li>为维护社会公众的利益</li>
            <li>为维护国家文物局综合行政管理平台的合法权益；</li>
            <li>符合其它相关要求。</li>
          </ol>
        </li>
        <li>
          六、禁止条款
          <p>
            注册用户有违反法律法规行为的，国家文物局综合行政管理平台有权终止为用户提供服务，并保留追责的权利。
          </p>
        </li>
        <li>
          七、免责声明
          <p>
            注册用户同意发生下列情形时，国家文物局综合行政管理平台将不承担任何责任，包括但不限于：
          </p>
          <ol>
            <li>
              因国家文物局综合行政管理平台不定期对提供网络服务的平台或相关的设备进行检修或者维护而导致的服务中断。
            </li>
            <li>
              因不可抗力、黑客攻击、病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵等原因而导致的用户信息泄漏、服务中断及其他损失。
            </li>
            <li>
              因注册用户所发布的言论或内容涉嫌构成违法和不良信息，国家文物局综合行政管理平台有权不经通知单方面采取删除、屏蔽或断开连接等措施。
            </li>
            <li>
              注册用户使用国家文物局综合行政管理平台服务过程中导致国家文物局综合行政管理平台或任何其他第三方产生损失的，用户应当承担全部责任。
            </li>
          </ol>
        </li>
        <li>
          八、其他规定
          <ol>
            <li>
              用户知悉并授权国家文物局综合行政管理平台在必需的情况下使用或与关联单位同步用户信息，以为用户提供征信及其他相关服务。
            </li>
            <li>
              本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
            </li>
            <li>
              如双方就本协议内容或执行发生任何争议，双方应协商解决；协商不成时，应向国家文物局综合行政管理平台运营方所在地人民法院提起诉讼解决。
            </li>
            <li>国家文物局综合行政管理平台保留对本协议的最终解释权。</li>
          </ol>
        </li>
      </ul>
    </div>
  </el-scrollbar>
</template>
<script>
export default {
  name: "bpsBps",
};
</script>

<style scoped lang="less">
.el-scrollbar {
  height: 100%;
  text-align: left !important;
  .form {
    width: 100%;
    // margin: 0 auto;
    padding: 20px;
    min-height: 495px;
    font-size: 15px;
    line-height: 20px;
    .border {
      border: 2px solid #b71c1c;
      margin-bottom: 20px;
    }
    p {
      margin: 10px 0;
      line-height: 20px;
      text-indent: 2em;
    }
    h3 {
      text-align: center;
      color: #b71c1c;
      font-size: 22px;
    }
    ul {
      li {
        padding: 5px 0;
      }
      p {
        text-indent: 2em;
      }
    }
    ol {
      list-style-type: decimal;
      margin-left: 21px;
    }
  }
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
li {
  display: inline;
}
</style>

